import React from "react";
import { EntryTypeInput, EntryTypeInputValue } from "guestlist/EntryTypeInput";
import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { RenderEditOptions } from "components/MainSectionTemplate/types";
import RequiredNumberInput from "components/ValidatedFields/RequiredNumberInput";
import { getUpdateGuestlistAccessTypeInstruction, GuestlistAccessTypeFormState } from "shared/utils/fieldsHelper/guestlistFields";

interface Props {
  list: server.dto.GuestlistList;
}

export const AccessTypeSidePanelDetails = (props: Props) => {
  const [formState, setFormState] = React.useState<GuestlistAccessTypeFormState>({
    quantity: props.list.quantity,
    entryType: serverReference.guestlistEntryTypes.find(et => et.value === props.list.entryType),
    entryTypeCustomName: props.list.entryTypeCustomName,
  });

  const onValueChanged = (key: string, value: any) => {
    if (key === "quantity") {
      setFormState((prevState) => ({
        ...prevState,
        quantity: value,
      }));
    } else if (key === "entryType") {
      setFormState((prevState) => ({
        ...prevState,
        entryType: value.entryType,
        entryTypeCustomName: value.customLabel,
      }));
    }
  }

  return <SidePanelDetailSectionTemplate
    isInPageEditable
    onValueChanged={onValueChanged}
    sections={[{
      key: "settings",
      type: "regular",
      hideTitle: true,
      title: RESX.Guestlist.List,
      fields: [{
        key: "entryType",
        label: RESX.GeneralLabels.Type,
        render: () => <>{formState.entryType.value === "customName" ? formState.entryTypeCustomName : formState.entryType.text}</>,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<EntryTypeInputValue>) => <EntryTypeInput
            value={value}
            focusOnMount
            validatorKey="entryType"
            onChange={(v, save) => onChange(v, save)}
            cancel={cancel}
            submit={submit}
          />,
          fullWidth: true,
          type: "custom",
          initialValue: { entryType: formState.entryType, customLabel: formState.entryTypeCustomName },
          submitChange: (value: EntryTypeInputValue) => window.CoreApi.Guestlist.UpdateGuestlistAccessType(
            getUpdateGuestlistAccessTypeInstruction(props.list.guestlistAccessTypeId, {
              ...formState,
              entryType: value.entryType,
              entryTypeCustomName: value.customLabel,
            }),
          ),
        }
      }, {
        key: "quantity",
        label: RESX.GeneralLabels.Available,
        render: () => <span>{`${formState.quantity} PAX`}</span>,
        inPageEdit: {
          render: ({ value, onChange, cancel }) => <RequiredNumberInput
            autoFocus
            width={75}
            validatorKey="pax"
            value={value}
            onChange={(v: number) => onChange(v)}
            onEnterPressed={(v: number) => onChange(v, true)}
            onEscPressed={() => cancel()}
            labelContent="PAX"
            canBeNegative={false}
            canBeEmpty={false}
            decimalPoints={0}
            maxValue={999}
          />,
          fullWidth: true,
          type: "custom",
          initialValue: formState.quantity,
          submitChange: (quantity: number) => window.CoreApi.Guestlist.UpdateGuestlistAccessType(
            getUpdateGuestlistAccessTypeInstruction(props.list.guestlistAccessTypeId, { ...formState, quantity }),
          ),
        },
      }]
    }]}
  />
}
